import { NgModule } from '@angular/core';
import { NgxModule } from '../../../../ngx/ngx.module';
import { UiModule } from '../../../../ui/ui.module';
import { OfferDrawSliderComponent } from './offer-draw-slider.component';

@NgModule({
	imports: [
		UiModule,
		NgxModule
	],
	declarations: [
		OfferDrawSliderComponent
	],
	exports: [
		OfferDrawSliderComponent
	],
})
export class OfferDrawSliderModule { }
